/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CountryCode } from '../enums/country-code';
export class HomeOfficeEntity extends Entity {
  categories: string[] | null = null;
  countryCode: CountryCode | null = null;
  defaultTimezone: string | null = null;
  id: string = '';
  maxHours: number = 0;
  name: string = '';
  isAustraliaHomeOffice?: boolean | null = null;
  isUSHomeOffice?: boolean | null = null;
  static override key = 'HomeOffice';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'HomeOffice' in input
    ) {
      const { HomeOffice: wrapped, ...rest } = input as {
        HomeOffice: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}